import type { ConsultReportContext } from '@/pages/gmb-audit/consult/utils/consultContext';

function Row({ icon, label, value }: { icon: string; label: string; value: string }) {
  return (
    <div className="flex items-start gap-2.5">
      <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-background-100 text-primary-700">
        <i className={`${icon} text-lg`} />
      </span>
      <div className="min-w-0">
        <p className="text-sm text-foreground-500">{label}</p>
        <p className="text-base font-semibold leading-snug text-foreground-950">{value}</p>
      </div>
    </div>
  );
}

/**
 * 「你剛完成的健診」小卡（V1 Conversion-1）。
 * 所有數字都只顯示 Backend 既有結果，不產生新分數 / 新排名 / 新診斷。
 */
export default function ConsultContextCard({ context }: { context: ConsultReportContext }) {
  const gradeText =
    context.healthGrade && context.healthGradeLabel
      ? `${context.healthGrade}｜${context.healthGradeLabel}`
      : context.healthGradeLabel || '';

  return (
    <section className="rounded-2xl border border-primary-200 bg-primary-50/60 p-5 shadow-card md:p-6">
      <div className="flex items-center gap-2.5">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-100 text-primary-800">
          <i className="ri-file-shield-2-line text-lg" />
        </span>
        <h2 className="text-lg font-bold text-foreground-950">你剛完成的健診</h2>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
        {context.displayName && (
          <Row icon="ri-store-2-line" label="店家" value={context.displayName} />
        )}

        {context.scoreInsufficient ? (
          <Row icon="ri-heart-pulse-line" label="健康度" value="資料不足，暫無法產生完整健康度" />
        ) : typeof context.score === 'number' ? (
          <Row icon="ri-heart-pulse-line" label="健康度" value={`${context.score} / 100${gradeText ? `（${gradeText}）` : ''}`} />
        ) : null}

        {context.largestGapLabel && (
          <Row icon="ri-focus-3-line" label="目前較需要注意" value={context.largestGapLabel} />
        )}

        {context.priorityLabel && (
          <Row icon="ri-arrow-up-circle-line" label="優先改善" value={context.priorityLabel} />
        )}
      </div>

      <p className="mt-5 text-sm text-foreground-500">
        這些是本次健診的結果摘要。你可以在下方補充目前最想改善的問題，讓顧問更了解你的狀況。
      </p>
    </section>
  );
}